import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/apiClient";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // CRITICAL: skip the /auth/me check when returning from Google OAuth; AuthCallback establishes the session first.
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    const token = localStorage.getItem("gb_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("gb_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("gb_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const applyGoogleSession = async (sessionId) => {
    const { data } = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } });
    localStorage.setItem("gb_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("gb_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, applyGoogleSession }}>
      {children}
    </AuthCtx.Provider>
  );
}
